// extracted by mini-css-extract-plugin
export default {"archiveButton":"organization-users-table-cell__archive-button__WFyZe"};